import { render, staticRenderFns } from "./ConsentCheckboxItem.vue?vue&type=template&id=9a1923d8&scoped=true&"
import script from "./ConsentCheckboxItem.vue?vue&type=script&lang=js&"
export * from "./ConsentCheckboxItem.vue?vue&type=script&lang=js&"
import style0 from "./ConsentCheckboxItem.vue?vue&type=style&index=0&id=9a1923d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1923d8",
  null
  
)

export default component.exports